module.exports = __webpack_public_path__ + "static/media/fight.5d947d18.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fight.gif
// module id = 960
// module chunks = 0